<script>
	import { fly } from 'svelte/transition';
	import IChatButton from './IChatButton.svelte';
	import IChatForm from './IChatForm.svelte';
	import { Button } from 'flowbite-svelte';
	import { XMark } from 'svelte-heros-v2';

	let showForm = false;
</script>

<div class="relative">
	<IChatButton on:click={() => (showForm = true)} />

	{#if showForm}
		<div class="absolute right-0 bottom-0" transition:fly={{ y: 100, duration: 300 }}>
			<div class="relative">
				<IChatForm />
				<div class="absolute top-0 -right-11">
					<Button
						on:click={() => (showForm = false)}
						class="!p-0.5 rounded-full bg-white hover:bg-white focus:right-0"
					>
						<XMark strokeWidth="2" class="text-gray-500 outline-none" />
					</Button>
				</div>
			</div>
		</div>
	{/if}
</div>
